import { render } from "./NewCheckout.vue?vue&type=template&id=6de61bd2&scoped=true"
import script from "./NewCheckout.vue?vue&type=script&lang=js"
export * from "./NewCheckout.vue?vue&type=script&lang=js"

import "./NewCheckout.vue?vue&type=style&index=0&id=6de61bd2&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/todaymeal_front/todaymeal_front/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6de61bd2"]])

export default __exports__